export const isNumberOutOfRange = (
  min?: number,
  max?: number,
  value?: number
): boolean => {
  if (value === undefined || value === null || isNaN(value)) {
    return true
  }

  if (min !== undefined && value < min) {
    return true
  }

  return max !== undefined && value > max
}
